<template>
  <b-container fluid class="title-ribbon">
    <b-row class="my-5" align-h="center">
      <b-col cols="10">
        <p class="title">{{ text }}</p>
				<p class="subtitle">{{ subtitle }}</p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    text: String,
		subtitle: String
  },
  methods: {
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    }
  }
}
</script>

<style scoped src="@/assets/css/title.css"/>
